import { Box, IconButton, Theme, Tooltip, useMediaQuery } from "@mui/material";
import { useState } from "react";
import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    CreateButton,
    EditButton,
    FunctionField,
    SelectField,
    TextInput,
    useRecordContext,
    useDataProvider,
    useNotify,
    useRefresh,
    Button,
} from "react-admin";
import DeleteIcon from '@mui/icons-material/Delete'; // 删除图标
import PasswordVerifiers from "../deploy/passwordVerifiers";

const IP_TYPE_CHOICES = [
    {
        id: 'ipv6',
        name: 'IPv6',
    },
    {
        id: 'ipv4',
        name: 'IPv4',
    }
]
const ListActions = () => {
    return (
        <TopToolbar>
            <CreateButton />
        </TopToolbar>
    );
};



export const DeleteWithConfirmButton = () => {
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [loading, setLoading] = useState(false);
    const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);

    const handleDeleteClick = () => {
        setPasswordDialogOpen(true);
    };

    const handleClosePasswordDialog = () => {
        setPasswordDialogOpen(false);
    };

    const handleDelete = () => {
        setLoading(true);
        dataProvider.delete('strategy', { id: record.id })
            .then(() => {
                notify(`${record.name} 已删除`, { type: 'success' });
                refresh();
            })
            .catch(error => {
                notify(`删除失败: ${error.message}`, { type: 'error' });
            })
            .finally(() => setLoading(false));
    };

    // 小屏幕使用图标按钮
    if (isSmallScreen) {
        return (
            <>
                <Tooltip title="删除" arrow>
                    <IconButton
                        onClick={handleDeleteClick}
                        disabled={loading}
                        color="error"
                        size="small"
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
                <PasswordVerifiers
                    open={passwordDialogOpen}
                    onClose={handleClosePasswordDialog}
                    onConfirm={handleDelete}
                />
            </>
        );
    }

    // 大屏幕使用带图标的文字按钮
    return (
        <>
            <Button
                label="删除"
                onClick={handleDeleteClick}
                disabled={loading}
                color="error"
                startIcon={<DeleteIcon />}
                sx={{
                    fontSize: '14px',
                    padding: '6px 12px',
                    minWidth: 'auto',
                }}
            />
            <PasswordVerifiers
                open={passwordDialogOpen}
                onClose={handleClosePasswordDialog}
                onConfirm={handleDelete}
            />
        </>
    );
};

export const strategyList = () => {
    const role = localStorage.getItem("permissions");

    let postFilters = [
        <TextInput
            alwaysOn
            source="name"
            label="策略名称"
        />,
        <TextInput
            alwaysOn
            source="region"
            label="行政区域"
        />
    ];

    return (
        <List filters={postFilters} actions={<ListActions />} empty={false} pagination={false}>
            <Datagrid bulkActionButtons={false} rowClick={false}>
                <TextField source="name" label="策略名称" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="startTime" label="开始流量时间" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="endTime" label="结束流量时间" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="region" label="行政区域" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />

                {/* 网速设定添加 % 符号 */}
                <FunctionField
                    source="networkSpeed"
                    label="网速设定"
                    render={(record) => `${record.networkSpeed || ''}%`}
                    sortable={false}
                />

                {/* CPU占比添加 % 符号 */}
                <FunctionField
                    source="cpuUsage"
                    label="CPU占比"
                    render={(record) => `${record.cpuUsage || ''}%`}
                    sortable={false}
                />

                {/* RAM占比添加 % 符号 */}
                <FunctionField
                    source="ramUsage"
                    label="RAM占比"
                    render={(record) => `${record.ramUsage || ''}%`}
                    sortable={false}
                />

                <SelectField
                    source="ipType"
                    label="IP类型"
                    choices={IP_TYPE_CHOICES}
                    sortable={false}
                />
                <FunctionField
                    label="操作"
                    render={() => (
                        <Box sx={{ justifyContent: 'center', display: 'flex', gap: '8px' }}>
                            <EditButton />
                            {role != 'ops' ? <DeleteWithConfirmButton /> : null}
                        </Box>
                    )}
                    sortable={false}
                />
            </Datagrid>
        </List>
    )
}